export const CLEAR_TIMER = 'timeTracker/CLEAR_TIMER';
export const SET_TIMER = 'timeTracker/SET_TIMER';
